import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModelViewerRenderMode } from '@utils';
import { RootState } from '@types';

interface State {
    modelIsRendered: boolean;
    wtIsActive: boolean;
    currentViewerRenderMode: ModelViewerRenderMode;
}

const initialState: State = {
    modelIsRendered: false,
    wtIsActive: false,
    currentViewerRenderMode: ModelViewerRenderMode.Solid,
};

export const viewerSlice = createSlice({
    name: 'viewer',
    initialState,
    reducers: {
        wtActivityChanged: (state, action: PayloadAction<boolean>) => {
            state.wtIsActive = action.payload;
        },
        setModelIsRendered: (state, action: PayloadAction<boolean>) => {
            state.modelIsRendered = action.payload;
        },
        setCurrentViewerRenderMode: (state, action: PayloadAction<ModelViewerRenderMode>) => {
            state.currentViewerRenderMode = action.payload;
        },
    },
});

export const viewerActions = viewerSlice.actions;

export const selectModelIsRendered = (state: RootState) => state.modelViewer.modelIsRendered;
export const selectWtIsActive = (state: RootState) => state.modelViewer.wtIsActive;
export const selectCurrentViewerRenderMode = (state: RootState) => state.modelViewer.currentViewerRenderMode;
